import { NgModule } from '@angular/core';

import { CountryFlagDirective } from './countryFlag/countryflag.directive';

@NgModule({
  declarations: [CountryFlagDirective],
  exports: [CountryFlagDirective],
})
export class DirectivesModule {}
